module.exports = __webpack_public_path__ + "media/src/assets/Images/ArrowRightBig-7c9dd2cdabdbec7e907f6acb63e096a0.svg";